import { useRender } from "../../context/renderContext";
import { useIssuesData } from "../../hooks/useIssues";
import IssueDonutCard from "../ui/IssueDonutCard";
const colors = ["#64b5f6", "#ff8a65", "#aed581", "#ffd54f", "#4db6ac", "#ba68c8"];
const PeopleDealingMentalHealth = () => {
  const { selectedOption, setSelectedOption, options } = useRender();
  const { issuesData } = useIssuesData();
  const handleChange = (event) => {
    setSelectedOption?.(event.target.value);
  };
  const prepareChartData = (mentalHealthData) => Object.entries(mentalHealthData ??{}).map(([label, value], index) => ({
    id: index,
    value,
    color: colors[index % colors.length],
    label
  }));
  const chartData = issuesData ? prepareChartData(issuesData["Mental Health Issues"]) : [];
  return <IssueDonutCard
    title="People dealing with mental health issues"
    count={issuesData?.mentalHealthIssuesCount || 0}
    caption="Total users dealing with mental health issues"
    chartData={chartData}
    chartTitle="Mental Health Issues"
    accent="violet"
    dropdown={{ value: selectedOption, onChange: handleChange, options }}
  />;
};
var PeopleDealingMentalHealth_default = PeopleDealingMentalHealth;
export {
  PeopleDealingMentalHealth_default as default
};